export default __webpack_public_path__ + "static/media/liked.a71605d6.svg";